import { ReactNode } from 'react';

import { ThemeProvider } from '@material-ui/core';

import { buiDarkTheme, buiLightTheme } from '@spotify/confidence-mui-bui-theme';

import { useBUITheme } from './useBUITheme';

export const MuiBuiDarkThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('dark');

  return <ThemeProvider theme={buiDarkTheme}>{children}</ThemeProvider>;
};

export const MuiBuiLightThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('light');

  return <ThemeProvider theme={buiLightTheme}>{children}</ThemeProvider>;
};
